<style lang="scss">
</style>

<script>
  import TextToggle from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/TextToggle.svelte";
  import { integrationStore } from "../../../stores";

  export let providerTitle = "";

  const handleToggle = (newValue) => {
    const value = newValue ? "enabled" : "disabled";
    $integrationStore.setValue("contactData", value, "dataRefresh");
  };
</script>

<TextToggle
  checked={$integrationStore.getValue("contactData", "dataRefresh") ===
    "enabled"}
  onToggle={handleToggle}
  label="Update Emails & Phones"
>
  <span slot="description"
    >When enabled, SourceWhale will include email addresses and phone numbers
    when refreshing contact data in {providerTitle}</span
  >
</TextToggle>
